import "./MaterialsAndGrades.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import TechnicalHero from "./sections/TechnicalHero";
import MaterialsGrid from "./sections/MaterialsGrid";
import StainlessComparison from "./sections/StainlessComparison";
import MeshSpecExamples from "./sections/MeshSpecExamples";
import CertificationCTA from "./sections/CertificationCTA";
import Footer from "@/reusable_sections/Footer";
export default function MaterialsAndGradesPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="MaterialsAndGrades" />
      <TechnicalHero />
      <MaterialsGrid />
      <StainlessComparison />
      <MeshSpecExamples />
      <CertificationCTA />
      <Footer />
    </div>;
}